<template>
  <div id="tablePage">
    <!-- 可用仓单 -->
    <div class="orderTable">
      <el-table
        ref="tableData"
        :data="tableData"
        :height="tableHeight"
        v-loading="loading"
      >
        <template slot="empty" v-if="!loading">
          <div v-if="isNetWrong" class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div>
          </div>
          <div v-else class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data">暂无数据</div>
          </div>
        </template>
        <el-table-column
          prop="warehouseId"
          label="仓单号"
        >
        </el-table-column>
        <el-table-column
          prop="commodityName"
          label="商品名称"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="仓库名称"
        >
        </el-table-column>
        <el-table-column
          prop="quantity"
          label="商品数量"
        >
        </el-table-column>
        <el-table-column
          prop="frozenQuantity"
          label="冻结数量"
        >
        </el-table-column>
        <el-table-column
          prop="unitQuantifier"
          label="单位"
          width="60"
        >
        </el-table-column>
        <el-table-column
          prop="weight"
          label="重量"
        >
        </el-table-column>
        <el-table-column
          prop="type"
          label="仓单类型"
        >
          <!-- <template slot-scope="scope">
            {{ scope.row.warehouseType | tradeTypeFormat }}
          </template> -->
        </el-table-column>
        <el-table-column
          prop="warehouseCode"
          label="仓单原始凭证号"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="90"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="更新时间"
          width="90"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.updateTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <span class="operation" v-if="util.floatSub(scope.row.quantity, scope.row.frozenQuantity) != 0" @click="gettingData(scope.row)">提货</span>
          </template>
        </el-table-column>
      </el-table>
      <el-row v-if="pageData.total">
        <el-col :span="24" class="paginateWrap">
          <el-pagination
            popper-class="_popStyle"
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="提货申请" center width="400px" :visible.sync="dialogFormVisible" class="mainDialog diveryDialog" :close-on-click-modal="false" :before-close="qxDialog">
      <div class="dialogTabs">
        <div :class="!dialogTab? 'dialogTab activeTab' : 'dialogTab'" @click="dialogTab = false">物流</div>
        <div :class="dialogTab? 'dialogTab activeTab' : 'dialogTab'" @click="dialogTab = true">自提</div>
      </div>
      <div class="itemSearch">
        <span class="title">提货数量</span>
        <div class="inputsWrap">
          <el-input v-model="transfer.deliveryQuantity" type="number" placeholder="请输入提货数量"></el-input>
        </div>
      </div>
      <div class="itemSearch">
        <span class="title">提货人</span>
        <div class="inputsWrap">
          <el-input v-model="transfer.consigneeName" placeholder="请输入提货人"></el-input>
        </div>
      </div>
      <div class="itemSearch">
        <span class="title">联系电话</span>
        <div class="inputsWrap">
          <el-input v-model="transfer.consigneePhone" maxlength="11" placeholder="请输入联系电话"></el-input>
        </div>
      </div>
      <div class="itemSearch" v-if="dialogTab">
        <span class="title">身份证号</span>
        <div class="inputsWrap">
          <el-input v-model="deliveryCard" maxlength="18" placeholder="请输入联系人身份证号"></el-input>
        </div>
      </div>
      <div class="itemSearch" v-if="!dialogTab">
        <span class="title">收货地址</span>
        <div class="inputsWrap">
          <el-input v-model="transfer.consigneeAddr" maxlength="30"  placeholder="请输入收货地址"></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" class="conBtn" :disabled="popupBtn" @click="tackAndLossConfirm">确定</el-button>
        <el-button class="canelBtn" @click="qxDialog">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/*global http protocol  util*/
import { mapGetters } from 'vuex'
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['warehouseId', 'isSearch'],
  data() {
    return {
      tableHeight: 0,
      loading: false,
      popupBtn: false,
      checked: false,
      tableData: [],
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      },
      // 表格label宽度
      tcdTableWidth: {
        bsFlag: 80,
        ocFlag: 110,
        closePl: 100
      },
      // 订单数据
      oOrderData: {
        takeProfitPointPriceShow: '',
        stopLossPointPriceShow: ''
      },
      dialogFormVisible: false,
      dialogTab: false,
      isNetWrong: false,
      transfer: {
        // 'deliveryQuantity': '', // 提货数量
        // 'pickType': 'Z', // 提货类型;Z：自提W：物流
        // 'consigneeName': '', // 提货人
        'consigneeAddr': '', // 收货地址
        'consigneePostCode': '', // 邮编
        'deliveryQuantity': '', // 提货数量
        'isCheck': '1', // 是否验证
        'consigneeName': '', // 提货人
        'consigneePhone': '', // 联系方式
        'warehousId': 0// 仓单id
      },
      deliveryCard: '' // 身份证号
    }
  },
  computed: {
    ...mapGetters(['sessionInfoGetter'])
  },
  watch: {
    isSearch(val) {
      if (val) {
        this.pageData.currentPage = 1
        this.showData()
      }
    }
  },
  mounted() {
    this.showData()
  },
  created() {
    window.onresize = () => {
      this.$nextTick(() => {
        this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      this.$refs['tableData'].doLayout()
    })
  },
  methods: {
    findUserStatusProcess() {
      http.postFront(protocol.param_findUserStatusProcess).then(response => {
        const { code, value } = response.data
        if (code === 0 || code === '0') {
          if (value && value.authentication && value.authentication.status) {
            this.deliveryCard = value.authentication.certificateNumber
          }
        }
      })
    },
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showData()
    },
    // 订单展示
    showData() {
      const that = this
      this.loading = true
      protocol.param_getWarehouseList.data.page = this.pageData.currentPage - 1
      protocol.param_getWarehouseList.data.size = '' + this.pageData.pageSize
      protocol.param_getWarehouseList.data.firmId = this.sessionInfoGetter.firmId
      protocol.param_getWarehouseList.data.warehouseId = this.warehouseId // 搜索仓单号
      protocol.param_getWarehouseList.data.sort = [
        {
          direction: 'DESC', // "//DESC或ASC",
          property: 'warehouseId' // "//排序属性"
        }
      ]
      http.gPost(protocol.param_getWarehouseList).then(response => {
        if (response.data.code != 0) {
          this.$message({ message: response.data.message })
          this.isNetWrong = true
        } else {
          this.isNetWrong = false
        }
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.pageData.total = response.data.value.totalElements
            const arr = response.data.value.content
            this.judgeDataType(arr)
            // this.tableData = arr
          }
        }
        this.loading = false
      }).catch((e) => {
        this.loading = false
        setTimeout(() => {
            that.showData()
          }, 1000)
        })
    },
    // 判断数据类型
    judgeDataType(arr) {
      const that = this
      this.each(arr, function(arrIndex) {
        arrIndex.textColor = ''
        // 判断时间
        that.modifyTime(arrIndex, 'createTime')
        that.modifyTime(arrIndex, 'updateTime')
      })
      this.tableData = arr
    },
    // 点击提货申请弹窗
    gettingData(obj) {
      // 获取订单信息
      this.oOrderData = obj
      // 显示弹窗
      this.dialogFormVisible = true
      // 默认选择物流
      this.dialogTab = false
      this.findUserStatusProcess()
    },
    qxDialog() {
      this.dialogFormVisible = false
      this.popupBtn = false
      this.transfer = {
        'consigneeAddr': '', // 收货地址
        'consigneePostCode': '', // 邮编
        'deliveryQuantity': '', // 提货数量
        'isCheck': '1', // 是否验证
        'consigneeName': '', // 提货人
        'consigneePhone': '', // 联系方式
        'warehousId': 0// 仓单id
      }
    },
    // 提货申请
    tackAndLossConfirm() {
      // const that = this
      if (this.popupBtn) {
        return
      }
      this.popupBtn = true
      if (!this.transfer.deliveryQuantity || Number(this.transfer.deliveryQuantity) <= 0 || isNaN(this.transfer.deliveryQuantity)) {
        this.$message('请输入正确的提货数量')
        this.popupBtn = false
        return
      } else if (Number(this.transfer.deliveryQuantity) > this.oOrderData.quantity) {
        this.$message('超出可提货数量,请重新输入')
        this.popupBtn = false
        return
      } else if (!this.transfer.consigneeName) {
        this.$message('请输入提货人')
        this.popupBtn = false
        return
      } else if (!util.isCNName(this.transfer.consigneeName)) {
        this.$message('请输入正确的提货人')
        this.popupBtn = false
      } else if (!this.transfer.consigneePhone) {
        this.$message('请输入联系电话')
        this.popupBtn = false
        return
      } else if (!util.isPoneAvailable(this.transfer.consigneePhone)) {
        this.$message('请输入11位联系电话')
        this.popupBtn = false
      } else if (this.dialogTab && !this.deliveryCard) {
        this.$message('请输入身份证号')
        this.popupBtn = false
        return
      } else if (this.dialogTab && !util.IdentityCodeValid(this.deliveryCard)) {
        this.$message('请输入正确的身份证号')
        this.popupBtn = false
      } else if (!this.dialogTab && !this.transfer.consigneeAddr) {
        this.$message('请输入收货地址')
        this.popupBtn = false
        return
      } else {
        protocol.param_addPick.data = JSON.parse(JSON.stringify(this.transfer))
        if (this.dialogTab) {
          protocol.param_addPick.data.consigneeAddr = ''
        }
        protocol.param_addPick.data.deliveryCard = this.deliveryCard
        protocol.param_addPick.data.warehousId = this.oOrderData.warehouseId
        // protocol.param_addPick.data.deliveryQuantity = Number(this.transfer.deliveryQuantity)
        protocol.param_addPick.data.deliveryQuantity = Number(this.transfer.deliveryQuantity)
        // debugger
        http.gPost(protocol.param_addPick).then(response => {
          if (response.data) {
            const { code, message } = response.data
            if (code == '0') {
              setTimeout(() => {
                this.showData()
                this.popupBtn = false
                this.$message(message)
                this.dialogFormVisible = false
                this.transfer = {
                  // 'deliveryQuantity': 0, // 提货数量
                  // 'pickType': 'Z', // 提货类型;Z：自提W：物流
                  // 'consigneeName': '', // 提货人
                  'consigneeAddr': '', // 收货地址
                  'consigneePostCode': '', // 邮编
                  'deliveryQuantity': '', // 提货数量
                  'isCheck': '1', // 是否验证
                  'consigneeName': '', // 提货人
                  'consigneePhone': '', // 联系方式
                  'warehousId': 0// 仓单id
                }
              }, 1000)
            } else {
              this.popupBtn = false
              this.$message(message)
            }
          }
        })
      }
    },
    // 分项排序
    eachSortChange(str) {
      return (protocol.queryUserClinches.data.sort[0].property = str)
    },
    // 合计
    getSummaries(param) {
      const { columns } = param
      const sums = []
      const that = this
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 3) {
          sums[index] = '共' + this.pageData.total + '条'
          return
        }
        if (index === 7) { // 成交数量
          sums[index] = that.TradeListSum.quantity
          return
        }
        if (index === 8) { // 成交金额
          sums[index] = that.TradeListSum.funds
          return
        }
        // if (index === 10) { // 转让存货价
        //   sums[index] = that.TradeListSum.fee
        //   return
        // }
        if (index === 10) { // 利润
          sums[index] = that.TradeListSum.closePl
          return
        }
        if (index === 11) { // 印花税
          sums[index] = that.TradeListSum.stampFee
          return
        }
        if (index === 12) { // 手续费
          sums[index] = that.TradeListSum.fee
          return
        }
        sums[index] = ''
      })
      return sums
    },
    // 根据语言改变样式
    setLanguageCss() {
      // 防止清缓存后数据消失
      this.$i18n.locale = localStorage.lang || navigator.language.slice(-2).toLowerCase()
      switch (localStorage.lang) {
        case 'en': {
          const tcdTableEnWidth = {
            bsFlag: 120,
            ocFlag: 150,
            closePl: 150
          }
          localStorage.setItem('tcdTableEnWidth', JSON.stringify(tcdTableEnWidth))
          this.tcdTableWidth = JSON.parse(localStorage.tcdTableEnWidth)
        }
          break
        default:
          break
      }
    }

  }

}
</script>
<style lang="scss" scoped>
.diveryDialog{
  .dialogTabs {
    display: flex;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
  }
  .dialogTab{
    // width: 120px;
    // height: 40px;
    margin-right: 30px;
    text-align: center;
    font-family: Source Han Sans SC;
    font-weight: bold;
    font-size: 18px;
    color: #999999;
    cursor: pointer;
  }
  .activeTab{
    color: #333333;
    position: relative;
    &::after {
      position: absolute;
      bottom: 0;
      left: 0;
      content: '';
      width: 100%;
      height: 2px;
      background: #666666;
      border-radius: 1px;
    }
  }
}
</style>
